/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_About_OptionsInputs */

const de_commons_footer_about_options = /** @type {(inputs: Commons_Footer_About_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionen`)
};

/** @type {(inputs: Commons_Footer_About_OptionsInputs) => LocalizedString} */
const en_commons_footer_about_options = de_commons_footer_about_options;

/**

* @param {Commons_Footer_About_OptionsInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_about_options = /** @type {((inputs?: Commons_Footer_About_OptionsInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_About_OptionsInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_about_options(inputs)
	return en_commons_footer_about_options(inputs)
});